import { Table, Button } from "antd";
import { PATH, eContentFields } from "../constant";
import { EditTable } from "./EditTable";
import { useUpdateEffect } from "ahooks";
import { useState } from "react";
import * as _ from "lodash";
import { AddTable } from "./AddTable";
import { HiOutlineTrash } from "react-icons/hi2";
import { useRouteMatch } from "react-router-dom";
import { getPage } from "../utils/get-page";
import styled from "styled-components";

export const StyledTable = styled(Table)`
  &.ant-table-pagination.ant-pagination {
    background-color: red;
  }
`;

export function MajorTable({
  dataSource,
  setDataSource,
  index,
}: {
  dataSource: any;
  setDataSource: any;
  index: number;
}) {
  const routeMatch = useRouteMatch();

  const columns = [
    {
      title: <div style={{ width: "100px" }}>Nghiệp vụ</div>,
      dataIndex: "eMajor",
      key: "eMajor",
      width: "100px",
      onCell: (_: any, index: any) => {
        if (index === 0) {
          return { rowSpan: 10 };
        }
        return { rowSpan: 0, colSpan: 0 };
      },
      render(value: any, record: any, index: number) {
        return record?.eMajor;
      },
    },
    {
      title: <div style={{ width: "20px" }}></div>,
      dataIndex: "action",
      key: "action",
      width: "20px",
      render: (value: any, _: any, index1: number) => {
        index1 = (currentPage - 1) * pageSize + index1;

        return (
          <div className="d-flex justify-content-between">
            <EditTable dataSource={dataSource} setDataSource={setDataSource} index={index1} indexParent={index} />

            <Button
              onClick={() => {
                const NUM_PAGES = Math.ceil(dataSource.length / pageSize);
                if ((dataSource[index].data.length - 1) % 10 === 0) {
                  if (currentPage >= 2 && currentPage === NUM_PAGES) setCurrentPage(currentPage - 1);
                }

                let newDataSource = [...dataSource];
                let item = newDataSource[index].data;
                item.splice(index1, 1);
                setDataSource(newDataSource);
              }}
              className="ml-1"
            >
              <HiOutlineTrash size={20} className="cursor-pointer" color="#dc2626" />
            </Button>
          </div>
        );
      },
      isHide: getPage(routeMatch) === PATH.HOME,
    },

    ...eContentFields.map((value, index) => {
      return {
        title: <div style={{ width: "100px" }}>{value.label}</div>,
        dataIndex: value.field,
        key: value.field,
        width: "100px",
      };
    }),
  ].filter((value: any) => value.isHide !== true);

  const [newDataSource, setNewDataSource] = useState(_.clone(dataSource[index].data));

  useUpdateEffect(() => {
    setNewDataSource(_.clone(dataSource[index].data));
  }, [dataSource]);

  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <div>
      <StyledTable
        rowClassName="cursor-pointer"
        columns={columns}
        dataSource={newDataSource}
        pagination={{
          onChange: (page) => {
            setCurrentPage(page);
          },
          current: currentPage,
        }}
        scroll={{
          x: "100vh",
        }}
      />
      <AddTable dataSource={dataSource} setDataSource={setDataSource} indexParent={index} />
    </div>
  );
}
